import { render } from "./CustomLabelSizes.vue?vue&type=template&id=0d0ce73e&scoped=true&ts=true"
import script from "./CustomLabelSizes.vue?vue&type=script&lang=ts"
export * from "./CustomLabelSizes.vue?vue&type=script&lang=ts"

import "./CustomLabelSizes.vue?vue&type=style&index=0&id=0d0ce73e&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0ce73e"]])

export default __exports__